var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgNftInfo = function SvgNftInfo(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "nft-info_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#nft-info_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M12 16.75c.213 0 .391-.072.535-.216A.726.726 0 0 0 12.75 16v-4.25a.726.726 0 0 0-.216-.534A.727.727 0 0 0 12 11a.725.725 0 0 0-.535.216.726.726 0 0 0-.215.534V16c0 .212.072.39.216.534a.726.726 0 0 0 .534.216Zm0-7.462c.229 0 .42-.077.575-.232a.781.781 0 0 0 .233-.575.782.782 0 0 0-.232-.576.782.782 0 0 0-.576-.232.781.781 0 0 0-.575.232.782.782 0 0 0-.233.576c0 .229.078.42.232.575a.781.781 0 0 0 .576.232Zm.002 12.212a9.255 9.255 0 0 1-3.705-.748 9.596 9.596 0 0 1-3.018-2.03 9.591 9.591 0 0 1-2.03-3.016 9.245 9.245 0 0 1-.749-3.704c0-1.314.25-2.55.748-3.705a9.597 9.597 0 0 1 2.03-3.017 9.592 9.592 0 0 1 3.016-2.032 9.245 9.245 0 0 1 3.704-.748c1.314 0 2.55.25 3.705.748a9.597 9.597 0 0 1 3.018 2.03 9.592 9.592 0 0 1 2.03 3.016 9.245 9.245 0 0 1 .749 3.704c0 1.314-.25 2.55-.748 3.705a9.597 9.597 0 0 1-2.03 3.018 9.59 9.59 0 0 1-3.016 2.03 9.245 9.245 0 0 1-3.704.749ZM12 20c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z",
    fill: "currentColor"
  }))));
};
export default SvgNftInfo;